module.exports = __webpack_public_path__ + "img/dr_7.6fc58c11.png";